import { render, staticRenderFns } from "./FAQsApp.vue?vue&type=template&id=70812932&"
import script from "./FAQsApp.vue?vue&type=script&lang=js&"
export * from "./FAQsApp.vue?vue&type=script&lang=js&"
import style0 from "./FAQsApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports